export default function addLeaflet() {
    const { L, app } = window;
    const { config, map } = app;

    const IconOptions = L.Icon.extend({
        options: {
            iconSize: [32, 32],
            iconAnchor: [16, 32],
        },
    });

    // Icon based on: "https://www.flaticon.com/authors/elegant-themes" "https://www.flaticon.com/" "http://creativecommons.org/licenses/by/3.0/"
    const icon = new IconOptions({ iconUrl: './static/markers/marker.svg' });
    const searchResultLayers = L.layerGroup().addTo(map);

    const style = (config.style) ? config.style : {
        pointStyle: {
            radius: 6,
            color: '#f77542',
            weight: 3,
            opacity: 1,
            fill: false,
            fillColor: '#fff',
            fillOpacity: 0,
        },
        polyStyle: {
            color: '#28d3d6',
            weight: 2,
            opacity: 1,
            fill: false,
            fillColor: '#fff',
            fillOpacity: 0,
        },
    };

    let preliminairyGeometry = false;

    function prelim(e) {
        if (e.geometry) {
            preliminairyGeometry = true;
            const geom = L.geoJSON(e.geometry);
            map.flyToBounds(geom.getBounds(), { maxZoom: 15 });
        } else {
            preliminairyGeometry = false;
        }
    }

    this.on('search-final', (e) => {
        if (e.geometry) {
            const attributes = style.polyStyle;
            if (this.options.usePins) {
                attributes.pointToLayer = function pointToLayer(point, latlng) {
                    return L.marker(latlng, { icon });
                };
            } else {
                attributes.pointToLayer = function pointToLayer(point, latlng) {
                    return L.circleMarker(latlng, style.pointStyle);
                };
            }
            const geom = L.geoJSON(e.geometry, attributes);
            const center = geom.getBounds().getCenter();
            const { type } = e.geometry.geometry;

            if (type === 'MultiPoint' || type === 'Point') { map.fireEvent('click', { latlng: center }); }
            if (!preliminairyGeometry) {
                map.flyToBounds(geom.getBounds(), { maxZoom: 15 });
                map.once('zoomend', () => {
                    if (!config.search.clickMapOnGeometry) {
                        geom.bindTooltip(e.meta.value, { offset: L.point(0, -20) });
                    }
                    searchResultLayers.clearLayers();
                    searchResultLayers.addLayer(geom);
                });
            } else if (!config.search.clickMapOnGeometry) {
                geom.bindTooltip(e.meta.value, { offset: L.point(0, -20) });
            }
            searchResultLayers.clearLayers();
            searchResultLayers.addLayer(geom);
        }
    });

    this.on('geolocation-final', (e) => {
        if (e.geometry) {
            const attributes = style.pointStyle;
            if (this.options.usePins) {
                attributes.pointToLayer = function pointToLayer(point, latlng) {
                    return L.marker(latlng, { icon });
                };
            } else {
                attributes.pointToLayer = function pointToLayer(point, latlng) {
                    return L.circleMarker(latlng, style.pointStyle);
                };
            }
            const geom = L.geoJSON(e.geometry, attributes);
            const center = geom.getBounds().getCenter();
            if (config.search.clickMapOnGeometry) {
                map.fireEvent('click', { latlng: center });
            } else {
                const tipText = `${e.information.adresseringsvejnavn}, ${e.information.husnr}. ${e.information.postnr}, ${e.information.postnrnavn}`;
                searchResultLayers.clearLayers();
                searchResultLayers.addLayer(geom.bindTooltip(tipText, { offset: L.point(0, -20) }));
            }
        }
    });

    this.on('search-preliminairy', e => prelim(e));
    this.on('geolocation-preliminairy', e => prelim(e));
}
